import { Card, CardContent, Typography } from '@mui/material'
import React from 'react'

const AccountDataInfoCard = ({header, data,icon}) => {
  return (
    <Card className='dataCard'>
        <CardContent className='cardContent'>
          {icon}
          <div className='dataDiv'>
            <Typography className='dataCardHeader'>{header}</Typography>
            <Typography className='dataCardData'>{data}</Typography>
          </div>
        </CardContent>
    </Card>
  )
}

export default AccountDataInfoCard

export const AccountDataRevenueCard = ({header, data, subheader}) => {
  return (
    <Card className='revenueCard'>
    <CardContent className='revenueCardContent'>
        <Typography className='revenueCardHeader'>{header}</Typography>
        <Typography className='revenueCardHeader'>{subheader}</Typography>
        <Typography className='dataCardData'>{data}</Typography>
    </CardContent>
</Card>
  )
}

  